/**
 * A Medicine or Dentistry school's interview timing, as the course page and
 * the interview's start screen describe it: the school's format, and, where
 * the school does not publish the timings itself, where they come from.
 * Timings from the timing audit (backend content/interview_timings.json).
 */
export function timingText(timing, institution) {
  if (!timing?.format) return '';
  const school = institution || 'The school';
  const note = {
    official_older: `${school} published these timings for a recent year.`,
    reported: `${school} doesn't publish these timings; they come from recent applicants.`,
    practice: `${school} doesn't publish its timings, so these are practice timings based on applicants' reports.`,
  }[timing.evidence];
  return note ? `${timing.format} ${note}` : timing.format;
}
